import { JsonApiPayload } from "services/interfaces/JsonApiPayload"

export class ConnectionPayload extends JsonApiPayload {
  id: string
  accountId: string
  active: boolean
  name: string
  code: string
  type: string
  description: string
  username: string
  password: string
  secondaryUsername: string
  secondaryPassword: string
  tokenExpiryDate: string
  metadata: {
    allowedParks: {
        clientId: number
        clientName: string
    }[]
  }

  static getSchema() {
    return super._getSchema(this, []);
  }
}
